module.exports = __webpack_public_path__ + "static/media/TRUEMONEY.8dc5f514.png";